var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileHeaderButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "33px",
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05D4\\u05D5\\u05E1\\u05E4\\u05EA-\\u05DC\\u05E7\\u05D7---\\u05DE\\u05D5\\u05D1\\u05D9\\u05D9\\u05DC-\\u05EA\\u05E4\\u05E8\\u05D9\\u05D8-\\u05D7\\u05DC\\u05D5\\u05DF-\\u05DE\\u05D5\\u05D3\\u05D0\\u05DC\\u05D9",
    transform: "translate(-319.000000, -31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(319.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.947368, 9.578947)",
    stroke: "#00458A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16.4473684,
    y1: 0.657894737,
    x2: 0.657894737,
    y2: 0.657894737,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.8157895,
    y1: 13.1842105,
    x2: 0.657894737,
    y2: 13.1842105,
    id: "Line-2-Copy-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.86842105,
    y1: 6.92105263,
    x2: 0.657894737,
    y2: 6.92105263,
    id: "Line-2-Copy"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHeaderButton);
export default __webpack_public_path__ + "static/media/mobile_header_button.4aa504ab5c8324fa5ccf0ef5b4adc55b.svg";
export { ForwardRef as ReactComponent };